import { connect } from "react-redux";
import { Badge, Chip, CircularProgress, Tooltip } from "@mui/material";
import logo from '../../assets/TikTokLogo.png';
import { toastr } from "react-redux-toastr";
import { useEffect } from "react";
import { setNewTikTokIntegrationService, disconnectTikTokIntegrationService } from "../../services/agent-post-ai.service";
import {
    deleteDriveUserThunk,
    getUserWithEmailThunk,
    updateDriveUserThunk,
    updateIndexUserThunk
} from "../../redux/users/users.thunk";
import {useState} from "react";

const CustomChip = (props) => {
    return (
        <Chip
            variant="filled"
            disabled={props.status === 'loading'}
            avatar={
                props.status === 'loading' ? (
                    <CircularProgress size={20} />
                ) : (
                    <img style={{ width: '35px', height: '35px' }} src={logo} alt="TikTok Logo" />
                )
            }
            label="TikTok"
            {...props}
        />
    );
}

const TikTokButton = (props) => {
    const [status, setStatus] = useState("initial")

    const existTikTokAccount = () => {
        return props.user.analytics_tiktok_integrations !== null && props.user.analytics_tiktok_integrations?.length > 0;
    }

    const disconnect = async () => {
        if (window.confirm(`Are you sure you want to disconnect your TikTok account ${props.user.analytics_tiktok_integrations[0]['userName']}?`)) {
            setStatus("loading")
            await disconnectTikTokIntegrationService(props.user.analytics_tiktok_integrations[0]['id']);
            await props.getUser(props.user.email);
            setStatus("loaded")
        }
    }

    const handleButtonClick = () => {
        const popup = window.open(`${process.env.REACT_APP_BACK_AI_POST}/auth/tiktok/auth_url`, 'popup', 'width=600,height=600');
        console.log("Popup opened");

        const handleMessage = async (event) => {
            if(event.data.integration_id == undefined)
                return;
            setStatus("loading")
            console.log("Received event TOKTOKT:", event.data);
            const { integration_id } = event.data;
            console.log("Received data:", integration_id);

            try {
                const response = await setNewTikTokIntegrationService(integration_id, props.user.id); // update the analitycs user ifd in the tiktok integration
                // console.log("RESPONSE INTEGRATION: ", accessToken, sub, vanityName, organizationList, props.user.id );
                console.log("RESPONSE INTEGRATION: ", integration_id, props.user.id, response);
                await props.getUser(props.user.email);

                toastr.success("Connected!", "You have successfully logged in to your TikTok account");
                // alert("TikTok integration successful");
            } catch (error) {
                console.error("Failed to set TikTok integration:", error);
                toastr.error("Failed to set TikTok integration");
                // alert("Failed to set TikTok integration");
            } finally {
                setStatus("loaded")
                window.removeEventListener('message', handleMessage);
                if (popup) {
                    popup.close();
                }
            }
        };

        window.addEventListener('message', handleMessage);
    };

    return (
        <Tooltip
            title={existTikTokAccount() ? props.user.analytics_tiktok_integrations[0]["userName"] : ''}
            className="w-100"
        >
            <Badge color="success" variant="dot" invisible={!existTikTokAccount()}>
                {existTikTokAccount() ? (
                    <CustomChip
                        label={<small className="text-black-50">Connected</small>}
                        className="py-4 w-100 justify-content-center"
                        onClick={() => {}}
                        onDelete={() => disconnect()}
                        status={status}
                    />
                ) : (
                    <CustomChip
                        className="py-4 w-100"
                        onClick={handleButtonClick}
                        status={status}
                    />
                )}
            </Badge>
        </Tooltip>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.users.user,
        status: state.users.status,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getUser: (email) => dispatch(getUserWithEmailThunk(email)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TikTokButton);
